import Api from '../api/index'

function persists(store) {
  const local = localStorage.getItem('VUEX:STATE')
  if (local) {
    store.replaceState(JSON.parse(local))
  }
  store.subscribe((mutation, state) => {
    localStorage.setItem('VUEX:STATE', JSON.stringify(state))
  })
}

export default {
  plugins: [
    persists
  ],
  modules: {},
  state: {
    sliders: []
  },
  mutations: {
    async setSlider(state, payload) {
      state.sliders = payload
    }
  },
  actions: {
    async getSlider({ commit }) {
      const res = await Api.getSlider()
      commit('setSlider', res.data)
    }
  }
}
